import * as S from "react";
import { useLayoutEffect as It, useEffect as Yt } from "react";
import * as qt from "react-dom";
const Xt = ["top", "right", "bottom", "left"], U = Math.min, $ = Math.max, st = Math.round, it = Math.floor, z = (t) => ({
  x: t,
  y: t
}), Ut = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Kt = {
  start: "end",
  end: "start"
};
function gt(t, e, n) {
  return $(t, U(e, n));
}
function q(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function X(t) {
  return t.split("-")[0];
}
function Z(t) {
  return t.split("-")[1];
}
function xt(t) {
  return t === "x" ? "y" : "x";
}
function yt(t) {
  return t === "y" ? "height" : "width";
}
function Y(t) {
  return ["top", "bottom"].includes(X(t)) ? "y" : "x";
}
function vt(t) {
  return xt(Y(t));
}
function Gt(t, e, n) {
  n === void 0 && (n = !1);
  const o = Z(t), i = vt(t), r = yt(i);
  let s = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (s = ct(s)), [s, ct(s)];
}
function Jt(t) {
  const e = ct(t);
  return [pt(t), e, pt(e)];
}
function pt(t) {
  return t.replace(/start|end/g, (e) => Kt[e]);
}
function Qt(t, e, n) {
  const o = ["left", "right"], i = ["right", "left"], r = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : o : e ? o : i;
    case "left":
    case "right":
      return e ? r : s;
    default:
      return [];
  }
}
function Zt(t, e, n, o) {
  const i = Z(t);
  let r = Qt(X(t), n === "start", o);
  return i && (r = r.map((s) => s + "-" + i), e && (r = r.concat(r.map(pt)))), r;
}
function ct(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Ut[e]);
}
function te(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function kt(t) {
  return typeof t != "number" ? te(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function lt(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: i
  } = t;
  return {
    width: o,
    height: i,
    top: n,
    left: e,
    right: e + o,
    bottom: n + i,
    x: e,
    y: n
  };
}
function Ct(t, e, n) {
  let {
    reference: o,
    floating: i
  } = t;
  const r = Y(e), s = vt(e), c = yt(s), f = X(e), l = r === "y", a = o.x + o.width / 2 - i.width / 2, d = o.y + o.height / 2 - i.height / 2, m = o[c] / 2 - i[c] / 2;
  let u;
  switch (f) {
    case "top":
      u = {
        x: a,
        y: o.y - i.height
      };
      break;
    case "bottom":
      u = {
        x: a,
        y: o.y + o.height
      };
      break;
    case "right":
      u = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      u = {
        x: o.x - i.width,
        y: d
      };
      break;
    default:
      u = {
        x: o.x,
        y: o.y
      };
  }
  switch (Z(e)) {
    case "start":
      u[s] -= m * (n && l ? -1 : 1);
      break;
    case "end":
      u[s] += m * (n && l ? -1 : 1);
      break;
  }
  return u;
}
const ee = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: s
  } = n, c = r.filter(Boolean), f = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let l = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: a,
    y: d
  } = Ct(l, o, f), m = o, u = {}, h = 0;
  for (let g = 0; g < c.length; g++) {
    const {
      name: p,
      fn: w
    } = c[g], {
      x: y,
      y: v,
      data: b,
      reset: x
    } = await w({
      x: a,
      y: d,
      initialPlacement: o,
      placement: m,
      strategy: i,
      middlewareData: u,
      rects: l,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    a = y ?? a, d = v ?? d, u = {
      ...u,
      [p]: {
        ...u[p],
        ...b
      }
    }, x && h <= 50 && (h++, typeof x == "object" && (x.placement && (m = x.placement), x.rects && (l = x.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : x.rects), {
      x: a,
      y: d
    } = Ct(l, m, f)), g = -1);
  }
  return {
    x: a,
    y: d,
    placement: m,
    strategy: i,
    middlewareData: u
  };
};
async function et(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: i,
    platform: r,
    rects: s,
    elements: c,
    strategy: f
  } = t, {
    boundary: l = "clippingAncestors",
    rootBoundary: a = "viewport",
    elementContext: d = "floating",
    altBoundary: m = !1,
    padding: u = 0
  } = q(e, t), h = kt(u), p = c[m ? d === "floating" ? "reference" : "floating" : d], w = lt(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(p))) == null || n ? p : p.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(c.floating)),
    boundary: l,
    rootBoundary: a,
    strategy: f
  })), y = d === "floating" ? {
    x: o,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, v = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(c.floating)), b = await (r.isElement == null ? void 0 : r.isElement(v)) ? await (r.getScale == null ? void 0 : r.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = lt(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: y,
    offsetParent: v,
    strategy: f
  }) : y);
  return {
    top: (w.top - x.top + h.top) / b.y,
    bottom: (x.bottom - w.bottom + h.bottom) / b.y,
    left: (w.left - x.left + h.left) / b.x,
    right: (x.right - w.right + h.right) / b.x
  };
}
const ne = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: r,
      platform: s,
      elements: c,
      middlewareData: f
    } = e, {
      element: l,
      padding: a = 0
    } = q(t, e) || {};
    if (l == null)
      return {};
    const d = kt(a), m = {
      x: n,
      y: o
    }, u = vt(i), h = yt(u), g = await s.getDimensions(l), p = u === "y", w = p ? "top" : "left", y = p ? "bottom" : "right", v = p ? "clientHeight" : "clientWidth", b = r.reference[h] + r.reference[u] - m[u] - r.floating[h], x = m[u] - r.reference[u], O = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let R = O ? O[v] : 0;
    (!R || !await (s.isElement == null ? void 0 : s.isElement(O))) && (R = c.floating[v] || r.floating[h]);
    const D = b / 2 - x / 2, B = R / 2 - g[h] / 2 - 1, C = U(d[w], B), H = U(d[y], B), F = C, P = R - g[h] - H, M = R / 2 - g[h] / 2 + D, k = gt(F, M, P), E = !f.arrow && Z(i) != null && M !== k && r.reference[h] / 2 - (M < F ? C : H) - g[h] / 2 < 0, N = E ? M < F ? M - F : M - P : 0;
    return {
      [u]: m[u] + N,
      data: {
        [u]: k,
        centerOffset: M - k - N,
        ...E && {
          alignmentOffset: N
        }
      },
      reset: E
    };
  }
}), oe = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: i,
        middlewareData: r,
        rects: s,
        initialPlacement: c,
        platform: f,
        elements: l
      } = e, {
        mainAxis: a = !0,
        crossAxis: d = !0,
        fallbackPlacements: m,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...p
      } = q(t, e);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const w = X(i), y = Y(c), v = X(c) === c, b = await (f.isRTL == null ? void 0 : f.isRTL(l.floating)), x = m || (v || !g ? [ct(c)] : Jt(c)), O = h !== "none";
      !m && O && x.push(...Zt(c, g, h, b));
      const R = [c, ...x], D = await et(e, p), B = [];
      let C = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (a && B.push(D[w]), d) {
        const k = Gt(i, s, b);
        B.push(D[k[0]], D[k[1]]);
      }
      if (C = [...C, {
        placement: i,
        overflows: B
      }], !B.every((k) => k <= 0)) {
        var H, F;
        const k = (((H = r.flip) == null ? void 0 : H.index) || 0) + 1, E = R[k];
        if (E) {
          var P;
          const A = d === "alignment" ? y !== Y(E) : !1, L = ((P = C[0]) == null ? void 0 : P.overflows[0]) > 0;
          if (!A || L)
            return {
              data: {
                index: k,
                overflows: C
              },
              reset: {
                placement: E
              }
            };
        }
        let N = (F = C.filter((A) => A.overflows[0] <= 0).sort((A, L) => A.overflows[1] - L.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!N)
          switch (u) {
            case "bestFit": {
              var M;
              const A = (M = C.filter((L) => {
                if (O) {
                  const T = Y(L.placement);
                  return T === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  T === "y";
                }
                return !0;
              }).map((L) => [L.placement, L.overflows.filter((T) => T > 0).reduce((T, jt) => T + jt, 0)]).sort((L, T) => L[1] - T[1])[0]) == null ? void 0 : M[0];
              A && (N = A);
              break;
            }
            case "initialPlacement":
              N = c;
              break;
          }
        if (i !== N)
          return {
            reset: {
              placement: N
            }
          };
      }
      return {};
    }
  };
};
function St(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Et(t) {
  return Xt.some((e) => t[e] >= 0);
}
const ie = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: o = "referenceHidden",
        ...i
      } = q(t, e);
      switch (o) {
        case "referenceHidden": {
          const r = await et(e, {
            ...i,
            elementContext: "reference"
          }), s = St(r, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Et(s)
            }
          };
        }
        case "escaped": {
          const r = await et(e, {
            ...i,
            altBoundary: !0
          }), s = St(r, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Et(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function re(t, e) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = t, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), s = X(n), c = Z(n), f = Y(n) === "y", l = ["left", "top"].includes(s) ? -1 : 1, a = r && f ? -1 : 1, d = q(e, t);
  let {
    mainAxis: m,
    crossAxis: u,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return c && typeof h == "number" && (u = c === "end" ? h * -1 : h), f ? {
    x: u * a,
    y: m * l
  } : {
    x: m * l,
    y: u * a
  };
}
const se = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: i,
        y: r,
        placement: s,
        middlewareData: c
      } = e, f = await re(e, t);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (o = c.arrow) != null && o.alignmentOffset ? {} : {
        x: i + f.x,
        y: r + f.y,
        data: {
          ...f,
          placement: s
        }
      };
    }
  };
}, ce = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: i
      } = e, {
        mainAxis: r = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (p) => {
            let {
              x: w,
              y
            } = p;
            return {
              x: w,
              y
            };
          }
        },
        ...f
      } = q(t, e), l = {
        x: n,
        y: o
      }, a = await et(e, f), d = Y(X(i)), m = xt(d);
      let u = l[m], h = l[d];
      if (r) {
        const p = m === "y" ? "top" : "left", w = m === "y" ? "bottom" : "right", y = u + a[p], v = u - a[w];
        u = gt(y, u, v);
      }
      if (s) {
        const p = d === "y" ? "top" : "left", w = d === "y" ? "bottom" : "right", y = h + a[p], v = h - a[w];
        h = gt(y, h, v);
      }
      const g = c.fn({
        ...e,
        [m]: u,
        [d]: h
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - o,
          enabled: {
            [m]: r,
            [d]: s
          }
        }
      };
    }
  };
}, le = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: o,
        placement: i,
        rects: r,
        middlewareData: s
      } = e, {
        offset: c = 0,
        mainAxis: f = !0,
        crossAxis: l = !0
      } = q(t, e), a = {
        x: n,
        y: o
      }, d = Y(i), m = xt(d);
      let u = a[m], h = a[d];
      const g = q(c, e), p = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (f) {
        const v = m === "y" ? "height" : "width", b = r.reference[m] - r.floating[v] + p.mainAxis, x = r.reference[m] + r.reference[v] - p.mainAxis;
        u < b ? u = b : u > x && (u = x);
      }
      if (l) {
        var w, y;
        const v = m === "y" ? "width" : "height", b = ["top", "left"].includes(X(i)), x = r.reference[d] - r.floating[v] + (b && ((w = s.offset) == null ? void 0 : w[d]) || 0) + (b ? 0 : p.crossAxis), O = r.reference[d] + r.reference[v] + (b ? 0 : ((y = s.offset) == null ? void 0 : y[d]) || 0) - (b ? p.crossAxis : 0);
        h < x ? h = x : h > O && (h = O);
      }
      return {
        [m]: u,
        [d]: h
      };
    }
  };
}, fe = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: i,
        rects: r,
        platform: s,
        elements: c
      } = e, {
        apply: f = () => {
        },
        ...l
      } = q(t, e), a = await et(e, l), d = X(i), m = Z(i), u = Y(i) === "y", {
        width: h,
        height: g
      } = r.floating;
      let p, w;
      d === "top" || d === "bottom" ? (p = d, w = m === (await (s.isRTL == null ? void 0 : s.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (w = d, p = m === "end" ? "top" : "bottom");
      const y = g - a.top - a.bottom, v = h - a.left - a.right, b = U(g - a[p], y), x = U(h - a[w], v), O = !e.middlewareData.shift;
      let R = b, D = x;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (D = v), (o = e.middlewareData.shift) != null && o.enabled.y && (R = y), O && !m) {
        const C = $(a.left, 0), H = $(a.right, 0), F = $(a.top, 0), P = $(a.bottom, 0);
        u ? D = h - 2 * (C !== 0 || H !== 0 ? C + H : $(a.left, a.right)) : R = g - 2 * (F !== 0 || P !== 0 ? F + P : $(a.top, a.bottom));
      }
      await f({
        ...e,
        availableWidth: D,
        availableHeight: R
      });
      const B = await s.getDimensions(c.floating);
      return h !== B.width || g !== B.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function at() {
  return typeof window < "u";
}
function tt(t) {
  return Ft(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function W(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function I(t) {
  var e;
  return (e = (Ft(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Ft(t) {
  return at() ? t instanceof Node || t instanceof W(t).Node : !1;
}
function V(t) {
  return at() ? t instanceof Element || t instanceof W(t).Element : !1;
}
function j(t) {
  return at() ? t instanceof HTMLElement || t instanceof W(t).HTMLElement : !1;
}
function Lt(t) {
  return !at() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof W(t).ShadowRoot;
}
function ot(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: i
  } = _(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !["inline", "contents"].includes(i);
}
function ae(t) {
  return ["table", "td", "th"].includes(tt(t));
}
function ut(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function bt(t) {
  const e = At(), n = V(t) ? _(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function ue(t) {
  let e = K(t);
  for (; j(e) && !Q(e); ) {
    if (bt(e))
      return e;
    if (ut(e))
      return null;
    e = K(e);
  }
  return null;
}
function At() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Q(t) {
  return ["html", "body", "#document"].includes(tt(t));
}
function _(t) {
  return W(t).getComputedStyle(t);
}
function dt(t) {
  return V(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function K(t) {
  if (tt(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Lt(t) && t.host || // Fallback.
    I(t)
  );
  return Lt(e) ? e.host : e;
}
function $t(t) {
  const e = K(t);
  return Q(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : j(e) && ot(e) ? e : $t(e);
}
function nt(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = $t(t), r = i === ((o = t.ownerDocument) == null ? void 0 : o.body), s = W(i);
  if (r) {
    const c = wt(s);
    return e.concat(s, s.visualViewport || [], ot(i) ? i : [], c && n ? nt(c) : []);
  }
  return e.concat(i, nt(i, [], n));
}
function wt(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function Wt(t) {
  const e = _(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const i = j(t), r = i ? t.offsetWidth : n, s = i ? t.offsetHeight : o, c = st(n) !== r || st(o) !== s;
  return c && (n = r, o = s), {
    width: n,
    height: o,
    $: c
  };
}
function Rt(t) {
  return V(t) ? t : t.contextElement;
}
function J(t) {
  const e = Rt(t);
  if (!j(e))
    return z(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: i,
    $: r
  } = Wt(e);
  let s = (r ? st(n.width) : n.width) / o, c = (r ? st(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const de = /* @__PURE__ */ z(0);
function Bt(t) {
  const e = W(t);
  return !At() || !e.visualViewport ? de : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function me(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== W(t) ? !1 : e;
}
function G(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), r = Rt(t);
  let s = z(1);
  e && (o ? V(o) && (s = J(o)) : s = J(t));
  const c = me(r, n, o) ? Bt(r) : z(0);
  let f = (i.left + c.x) / s.x, l = (i.top + c.y) / s.y, a = i.width / s.x, d = i.height / s.y;
  if (r) {
    const m = W(r), u = o && V(o) ? W(o) : o;
    let h = m, g = wt(h);
    for (; g && o && u !== h; ) {
      const p = J(g), w = g.getBoundingClientRect(), y = _(g), v = w.left + (g.clientLeft + parseFloat(y.paddingLeft)) * p.x, b = w.top + (g.clientTop + parseFloat(y.paddingTop)) * p.y;
      f *= p.x, l *= p.y, a *= p.x, d *= p.y, f += v, l += b, h = W(g), g = wt(h);
    }
  }
  return lt({
    width: a,
    height: d,
    x: f,
    y: l
  });
}
function Ot(t, e) {
  const n = dt(t).scrollLeft;
  return e ? e.left + n : G(I(t)).left + n;
}
function Ht(t, e, n) {
  n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), i = o.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Ot(t, o)
  )), r = o.top + e.scrollTop;
  return {
    x: i,
    y: r
  };
}
function he(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: i
  } = t;
  const r = i === "fixed", s = I(o), c = e ? ut(e.floating) : !1;
  if (o === s || c && r)
    return n;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = z(1);
  const a = z(0), d = j(o);
  if ((d || !d && !r) && ((tt(o) !== "body" || ot(s)) && (f = dt(o)), j(o))) {
    const u = G(o);
    l = J(o), a.x = u.x + o.clientLeft, a.y = u.y + o.clientTop;
  }
  const m = s && !d && !r ? Ht(s, f, !0) : z(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - f.scrollLeft * l.x + a.x + m.x,
    y: n.y * l.y - f.scrollTop * l.y + a.y + m.y
  };
}
function ge(t) {
  return Array.from(t.getClientRects());
}
function pe(t) {
  const e = I(t), n = dt(t), o = t.ownerDocument.body, i = $(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), r = $(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + Ot(t);
  const c = -n.scrollTop;
  return _(o).direction === "rtl" && (s += $(e.clientWidth, o.clientWidth) - i), {
    width: i,
    height: r,
    x: s,
    y: c
  };
}
function we(t, e) {
  const n = W(t), o = I(t), i = n.visualViewport;
  let r = o.clientWidth, s = o.clientHeight, c = 0, f = 0;
  if (i) {
    r = i.width, s = i.height;
    const l = At();
    (!l || l && e === "fixed") && (c = i.offsetLeft, f = i.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: c,
    y: f
  };
}
function xe(t, e) {
  const n = G(t, !0, e === "fixed"), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = j(t) ? J(t) : z(1), s = t.clientWidth * r.x, c = t.clientHeight * r.y, f = i * r.x, l = o * r.y;
  return {
    width: s,
    height: c,
    x: f,
    y: l
  };
}
function Tt(t, e, n) {
  let o;
  if (e === "viewport")
    o = we(t, n);
  else if (e === "document")
    o = pe(I(t));
  else if (V(e))
    o = xe(e, n);
  else {
    const i = Bt(t);
    o = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return lt(o);
}
function Nt(t, e) {
  const n = K(t);
  return n === e || !V(n) || Q(n) ? !1 : _(n).position === "fixed" || Nt(n, e);
}
function ye(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = nt(t, [], !1).filter((c) => V(c) && tt(c) !== "body"), i = null;
  const r = _(t).position === "fixed";
  let s = r ? K(t) : t;
  for (; V(s) && !Q(s); ) {
    const c = _(s), f = bt(s);
    !f && c.position === "fixed" && (i = null), (r ? !f && !i : !f && c.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || ot(s) && !f && Nt(t, s)) ? o = o.filter((a) => a !== s) : i = c, s = K(s);
  }
  return e.set(t, o), o;
}
function ve(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = t;
  const s = [...n === "clippingAncestors" ? ut(e) ? [] : ye(e, this._c) : [].concat(n), o], c = s[0], f = s.reduce((l, a) => {
    const d = Tt(e, a, i);
    return l.top = $(d.top, l.top), l.right = U(d.right, l.right), l.bottom = U(d.bottom, l.bottom), l.left = $(d.left, l.left), l;
  }, Tt(e, c, i));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function be(t) {
  const {
    width: e,
    height: n
  } = Wt(t);
  return {
    width: e,
    height: n
  };
}
function Ae(t, e, n) {
  const o = j(e), i = I(e), r = n === "fixed", s = G(t, !0, r, e);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = z(0);
  function l() {
    f.x = Ot(i);
  }
  if (o || !o && !r)
    if ((tt(e) !== "body" || ot(i)) && (c = dt(e)), o) {
      const u = G(e, !0, r, e);
      f.x = u.x + e.clientLeft, f.y = u.y + e.clientTop;
    } else i && l();
  r && !o && i && l();
  const a = i && !o && !r ? Ht(i, c) : z(0), d = s.left + c.scrollLeft - f.x - a.x, m = s.top + c.scrollTop - f.y - a.y;
  return {
    x: d,
    y: m,
    width: s.width,
    height: s.height
  };
}
function mt(t) {
  return _(t).position === "static";
}
function Dt(t, e) {
  if (!j(t) || _(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return I(t) === n && (n = n.ownerDocument.body), n;
}
function Vt(t, e) {
  const n = W(t);
  if (ut(t))
    return n;
  if (!j(t)) {
    let i = K(t);
    for (; i && !Q(i); ) {
      if (V(i) && !mt(i))
        return i;
      i = K(i);
    }
    return n;
  }
  let o = Dt(t, e);
  for (; o && ae(o) && mt(o); )
    o = Dt(o, e);
  return o && Q(o) && mt(o) && !bt(o) ? n : o || ue(t) || n;
}
const Re = async function(t) {
  const e = this.getOffsetParent || Vt, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: Ae(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Oe(t) {
  return _(t).direction === "rtl";
}
const Ce = {
  convertOffsetParentRelativeRectToViewportRelativeRect: he,
  getDocumentElement: I,
  getClippingRect: ve,
  getOffsetParent: Vt,
  getElementRects: Re,
  getClientRects: ge,
  getDimensions: be,
  getScale: J,
  isElement: V,
  isRTL: Oe
};
function _t(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function Se(t, e) {
  let n = null, o;
  const i = I(t);
  function r() {
    var c;
    clearTimeout(o), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, f) {
    c === void 0 && (c = !1), f === void 0 && (f = 1), r();
    const l = t.getBoundingClientRect(), {
      left: a,
      top: d,
      width: m,
      height: u
    } = l;
    if (c || e(), !m || !u)
      return;
    const h = it(d), g = it(i.clientWidth - (a + m)), p = it(i.clientHeight - (d + u)), w = it(a), v = {
      rootMargin: -h + "px " + -g + "px " + -p + "px " + -w + "px",
      threshold: $(0, U(1, f)) || 1
    };
    let b = !0;
    function x(O) {
      const R = O[0].intersectionRatio;
      if (R !== f) {
        if (!b)
          return s();
        R ? s(!1, R) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      R === 1 && !_t(l, t.getBoundingClientRect()) && s(), b = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...v,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, v);
    }
    n.observe(t);
  }
  return s(!0), r;
}
function We(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = o, l = Rt(t), a = i || r ? [...l ? nt(l) : [], ...nt(e)] : [];
  a.forEach((w) => {
    i && w.addEventListener("scroll", n, {
      passive: !0
    }), r && w.addEventListener("resize", n);
  });
  const d = l && c ? Se(l, n) : null;
  let m = -1, u = null;
  s && (u = new ResizeObserver((w) => {
    let [y] = w;
    y && y.target === l && u && (u.unobserve(e), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var v;
      (v = u) == null || v.observe(e);
    })), n();
  }), l && !f && u.observe(l), u.observe(e));
  let h, g = f ? G(t) : null;
  f && p();
  function p() {
    const w = G(t);
    g && !_t(g, w) && n(), g = w, h = requestAnimationFrame(p);
  }
  return n(), () => {
    var w;
    a.forEach((y) => {
      i && y.removeEventListener("scroll", n), r && y.removeEventListener("resize", n);
    }), d == null || d(), (w = u) == null || w.disconnect(), u = null, f && cancelAnimationFrame(h);
  };
}
const Ee = se, Le = ce, Te = oe, De = fe, Pe = ie, Pt = ne, Me = le, ke = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: Ce,
    ...n
  }, r = {
    ...i.platform,
    _c: o
  };
  return ee(t, e, {
    ...i,
    platform: r
  });
};
var rt = typeof document < "u" ? It : Yt;
function ft(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, i;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!ft(t[o], e[o]))
          return !1;
      return !0;
    }
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, i[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const r = i[o];
      if (!(r === "_owner" && t.$$typeof) && !ft(t[r], e[r]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function zt(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Mt(t, e) {
  const n = zt(t);
  return Math.round(e * n) / n;
}
function ht(t) {
  const e = S.useRef(t);
  return rt(() => {
    e.current = t;
  }), e;
}
function Be(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: i,
    elements: {
      reference: r,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: f,
    open: l
  } = t, [a, d] = S.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [m, u] = S.useState(o);
  ft(m, o) || u(o);
  const [h, g] = S.useState(null), [p, w] = S.useState(null), y = S.useCallback((A) => {
    A !== O.current && (O.current = A, g(A));
  }, []), v = S.useCallback((A) => {
    A !== R.current && (R.current = A, w(A));
  }, []), b = r || h, x = s || p, O = S.useRef(null), R = S.useRef(null), D = S.useRef(a), B = f != null, C = ht(f), H = ht(i), F = ht(l), P = S.useCallback(() => {
    if (!O.current || !R.current)
      return;
    const A = {
      placement: e,
      strategy: n,
      middleware: m
    };
    H.current && (A.platform = H.current), ke(O.current, R.current, A).then((L) => {
      const T = {
        ...L,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: F.current !== !1
      };
      M.current && !ft(D.current, T) && (D.current = T, qt.flushSync(() => {
        d(T);
      }));
    });
  }, [m, e, n, H, F]);
  rt(() => {
    l === !1 && D.current.isPositioned && (D.current.isPositioned = !1, d((A) => ({
      ...A,
      isPositioned: !1
    })));
  }, [l]);
  const M = S.useRef(!1);
  rt(() => (M.current = !0, () => {
    M.current = !1;
  }), []), rt(() => {
    if (b && (O.current = b), x && (R.current = x), b && x) {
      if (C.current)
        return C.current(b, x, P);
      P();
    }
  }, [b, x, P, C, B]);
  const k = S.useMemo(() => ({
    reference: O,
    floating: R,
    setReference: y,
    setFloating: v
  }), [y, v]), E = S.useMemo(() => ({
    reference: b,
    floating: x
  }), [b, x]), N = S.useMemo(() => {
    const A = {
      position: n,
      left: 0,
      top: 0
    };
    if (!E.floating)
      return A;
    const L = Mt(E.floating, a.x), T = Mt(E.floating, a.y);
    return c ? {
      ...A,
      transform: "translate(" + L + "px, " + T + "px)",
      ...zt(E.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: L,
      top: T
    };
  }, [n, c, E.floating, a.x, a.y]);
  return S.useMemo(() => ({
    ...a,
    update: P,
    refs: k,
    elements: E,
    floatingStyles: N
  }), [a, P, k, E, N]);
}
const Fe = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: o,
        padding: i
      } = typeof t == "function" ? t(n) : t;
      return o && e(o) ? o.current != null ? Pt({
        element: o.current,
        padding: i
      }).fn(n) : {} : o ? Pt({
        element: o,
        padding: i
      }).fn(n) : {};
    }
  };
}, He = (t, e) => ({
  ...Ee(t),
  options: [t, e]
}), Ne = (t, e) => ({
  ...Le(t),
  options: [t, e]
}), Ve = (t, e) => ({
  ...Me(t),
  options: [t, e]
}), _e = (t, e) => ({
  ...Te(t),
  options: [t, e]
}), ze = (t, e) => ({
  ...De(t),
  options: [t, e]
}), je = (t, e) => ({
  ...Pe(t),
  options: [t, e]
}), Ie = (t, e) => ({
  ...Fe(t),
  options: [t, e]
});
export {
  ze as a,
  Ie as b,
  We as c,
  _e as f,
  je as h,
  Ve as l,
  He as o,
  Ne as s,
  Be as u
};
//# sourceMappingURL=floating-ui.react-dom-JfyihLpw.js.map
